import "./NewsTicker.scss";
import "../../mediaLanding/picturesAndVideosSlider/PicturesAndVideosSlider.scss";
// import { FormattedMessage } from "react-intl";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
// import CardTool from "../cardTool/CardTool";
import DataNotFound from "../DataNotFound/DataNotFound";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
// import ChevronIcon from "svg-icons/chevron-icon";
import { useSelector } from "react-redux";
import Marquee from "react-fast-marquee";
// import ContentLoading from "component/LoadingComponent/ContentLoading";
import { API_BASE_URL } from "configs/AppConfig";
import Linkable from "component/LinkableComponent/linkable-component";

function NewsTicker() {
  const direction = useSelector(({ theme }) => theme.direction);
  const currentLocale = useSelector(({ theme }) => theme.locale);

  const newsTicker = process.env.PUBLIC_URL + "/image/newsTicker.png";

  const news = useSWR({
    url: END_POINTS.NEWS_BAR,
  });

  const rendernews = () => {
    const newsData =
      news.error ||
      news.isLoading ||
      news.data === undefined ||
      news.data.data === undefined
        ? []
        : news.data.data;

    const rendering = newsData.map(
      ({ title, link, isPdf, newsBarTranslation }, i) => {
        return (
          <div
            key={i}
            className="newsTicker-item"
            style={{ maxWidth: "fit-content" }}
          >
            {/* <ChevronIcon width={20} height={12} color={"#FFF"} /> */}
            <Linkable
              link={
                isPdf
                  ? LabelLangString({
                      id: "link",
                      currentLocale: currentLocale,
                      defaultValue: API_BASE_URL + link,
                      translations: [
                        ...newsBarTranslation,
                        ...[{
                          locale: "en",
                          link: API_BASE_URL + link,
                        }],
                      ],
                    })
                  : LabelLangString({
                      id: "link",
                      currentLocale: currentLocale,
                      defaultValue: link,
                      translations: [
                        ...newsBarTranslation,
                        ...[{
                          locale: "en",
                          link: link,
                        }],
                      ],
                    })
              }
              style={{ color: "#FFF", fontWeight: "bold" }}
              isInternal={false}
              target="_blank"
            >
              {LabelLangString({
                id: "title",
                currentLocale: currentLocale,
                defaultValue: title,
                translations: newsBarTranslation,
              })}
            </Linkable>

            <img src={newsTicker} alt="news-ticker" />

            {/* <a href={link}>
                <span>
                  <FormattedMessage id="more" />
                </span>
                <img
                  loading="lazy"
                  src={process.env.PUBLIC_URL + "/image/dots.svg"}
                  alt="item-news"
                />
              </a> */}
          </div>
        );
      }
    );
    return rendering;
  };

  //View translated items only
  // const getCurrentLocaleDataLength = () => {
  //   const newsData =
  //     news.error ||
  //     news.isLoading ||
  //     news.data === undefined ||
  //     news.data.data === undefined
  //       ? []
  //       : news.data.data;

  //   return currentLocale == "ar" ? newsData : null;
  // };

  return (
    // getCurrentLocaleDataLength() && (
    // <ContentLoading
    //   isLoading={news.isLoading}
    //   height="0px"
    //   iconWidth="50px"
    //   marginTop="0px"
    // >
    !news.isLoading && (
      <div className="newsTicker">
        <div className="container">
          {Object.keys(rendernews()).length > 0 ? (
            <div dir="ltr">
              <Marquee
                play
                pauseOnHover
                speed={70}
                direction={direction === "rtl" ? "right" : "left"}
              >
                {rendernews()}
              </Marquee>
            </div>
          ) : (
            <DataNotFound />
          )}
        </div>
      </div>
    )
    // </ContentLoading>
    // )
  );
}

export default NewsTicker;
